/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";

const SimplicityDrawer = (props) => {
    
    const { open, children } = props || {};
    const drawerWidth = 200;
    
    const openTransition = (theme) => ({
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: "hidden",
    });
    
    const closeTransition = (theme) => ({
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: `calc(${theme.spacing(7)} + 1px)`,
        [theme.breakpoints.up("sm")]: {
            width: `calc(${theme.spacing(8)} + 1px)`,
        },
    });
    
    const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...(open && {
            ...openTransition(theme),
            "& .MuiDrawer-paper": openTransition(theme),
        }),
        ...(!open && {
            ...closeTransition(theme),
            "& .MuiDrawer-paper": closeTransition(theme),
        }),
    }));
    
    
    return (
        <Drawer 
            variant='permanent'
            open={open}
            className='simplicity-side-nav no-print'
        >
            {children}
        </Drawer>
    );
};

export { SimplicityDrawer };
